// localStorage keys for the Cognito tokens posted back by login.kast-dev.net.
export const LS_KEYS = {
  accessToken: "auth_access_token",
  idToken: "auth_id_token",
  refreshToken: "auth_refresh_token",
  username: "userEmail",
} as const;

export const LOGIN_URL = "https://login.kast-dev.net";

// Where redirectToLogin stashes the pre-login path for HashTokenHandler.
export const POST_LOGIN_PATH_KEY = "post_login_path";
